// ======================================================================
// 📁 File: BOQKpiBar.jsx
// Path:
// src/modules/ppe/pages/engineering/boq/BOQKpiBar.jsx
// ======================================================================
//
// PURPOSE:
//   - KPI cards for BOQ Master list
//   - Same UI as RoutingKpiBar.jsx
// ======================================================================

import React from "react";

export default function BOQKpiBar({ stats }) {
  const items = [
    {
      label: "Total BOMs",
      value: stats.total || 0,
      color: "#2563eb",
    },
    {
      label: "Draft",
      value: stats.draft || 0,
      color: "#f59e0b",
    },
    {
      label: "Approved",
      value: stats.approved || 0,
      color: "#16a34a",
    },
    {
      label: "Inactive",
      value: stats.inactive || 0,
      color: "#6b7280",
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit, minmax(180px, 1fr))",
        gap: 16,
        marginBottom: 20,
      }}
    >
      {items.map((i) => (
        <div
          key={i.label}
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: 16,
            borderLeft: `6px solid ${i.color}`,
            boxShadow:
              "0 1px 2px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              fontSize: 13,
              color: "#6b7280",
              marginBottom: 6,
            }}
          >
            {i.label}
          </div>

          <div
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            {i.value}
          </div>
        </div>
      ))}
    </div>
  );
}
